import addError from '../../../utils/error.jsx';

export function request(chatId, messageId) {
    return {
        type: 'TRADER_CHAT_DELETE_MESSAGE_REQUEST',
        chatId,
        messageId
    };
}

export function error(chatId, errors) {
    addError(errors);

    return {
        type: 'TRADER_CHAT_DELETE_MESSAGE_ERROR',
        chatId,
        errors
    };
}

export function finish(chatId, messageId) {
    return {
        type: 'TRADER_CHAT_DELETE_MESSAGE_FINISH',
        chatId,
        messageId
    };
}
